export class TranslateService {

    private static readonly _en = {
        LOGIN: {
            TITLE: "Log In",
            BUTTON_TEXT: "Log In",
            EMAIL: "Email",
            PASSWORD: "Password",
            FORGOT_YOUR_PASSWORD: "Forgot your password?",
            SIGN_UP: "Sign Up",
            SIGN_UP_QUESTION: "New to this site?",
        },
        REGISTER: {
            TITLE: "Sign Up",
            EMAIL: "Email",
            PASSWORD: "Password",
            SUBMIT_TEXT: "Sign Up",
            LOG_IN: "Log In",
            LOG_IN_QUESTION: "Already have an account?"
        },
        RECOVERY: {
            DEFAULT_TITLE: "Password Recovery",
            DEFAULT_SUBTITLE: "Enter your login email and we’ll send you a link to reset your password.",
            DEFAULT_SUBMIT_MESSAGE: "A link to reset your password has been emailed to you.",
            DEFAULT_EMAIL_CAPTION: "Email",
            DEFAULT_SUBMIT_TEXT: "Send",
            RETURN_TO_LOG_IN: "Return to Log In",
        },
        RESET_PASSWORD: {
            DEFAULT_TITLE: "New Password",
            DEFAULT_SUBTITLE: "Please enter new password and confirm.",
            DEFAULT_PASSWORD_CAPTION: "Password",
            DEFAULT_CONFIRM_PASSWORD_CAPTION: "Confirm Password",
            DEFAULT_SUBMIT_TEXT: "Change",
            DEFAULT_SUBMIT_MESSAGE: "The password has been successfully changed. You will be redirected to the log in page."
        },
        MENU_WIDGET: {
            DEFAULT_MORE_LINK_TEXT: "More"
        },
        STORE: {
            SUFFIX: "store"
        },
        GDPR: {
            BY_CLICKING_THE: "By clicking the \"",
            YOU_GIVE_US_PERMISSION: "\" button, you give us permission to send you marketing and other email communications. You may opt-out at any time.",
            I_ACCEPT: "I agree to the ",
            PRIVACY_POLICY: "Privacy Policy"
        }
    };

    private static readonly _ru = {
        LOGIN: {
            TITLE: "Войти",
            BUTTON_TEXT: "Войти",
            EMAIL: "Email",
            PASSWORD: "Пароль",
            FORGOT_YOUR_PASSWORD: "Забыли пароль?",
            SIGN_UP: "Регистрация",
            SIGN_UP_QUESTION: "Нет личного кабинета?",
        },
        REGISTER: {
            TITLE: "Регистрация",
            EMAIL: "Email",
            PASSWORD: "Пароль",
            SUBMIT_TEXT: "Зарегистрироваться",
            LOG_IN: "Войти",
            LOG_IN_QUESTION: "Уже есть личный кабинет?"
        },
        RECOVERY: {
            DEFAULT_TITLE: "Восстановление пароля",
            DEFAULT_SUBTITLE: "Мы вышлем вам инструкции по сбросу вашего пароля на email.",
            DEFAULT_SUBMIT_MESSAGE: "Вам по email была отправлена ссылка для сброса вашего пароля.",
            DEFAULT_EMAIL_CAPTION: "Ваш Email",
            DEFAULT_SUBMIT_TEXT: "Отправить",
            RETURN_TO_LOG_IN: "Вернуться для входа",
        },
        RESET_PASSWORD: {
            DEFAULT_TITLE: "Новый пароль",
            DEFAULT_SUBTITLE: "Пожалуйста, введите новый пароль.",
            DEFAULT_PASSWORD_CAPTION: "Пароль",
            DEFAULT_CONFIRM_PASSWORD_CAPTION: "Подтвердите пароль",
            DEFAULT_SUBMIT_TEXT: "Отправить",
            DEFAULT_SUBMIT_MESSAGE: "Пароль успешно изменен. Вы будете перенаправлены на страницу входа."
        },
        MENU_WIDGET: {
            DEFAULT_MORE_LINK_TEXT: "Ещё"
        },
        STORE: {
            SUFFIX: "магазин"
        },
        GDPR: {
            BY_CLICKING_THE: "Нажимая кнопку \"",
            YOU_GIVE_US_PERMISSION: "\", вы даете нам разрешение на отправку вам маркетинговых и других сообщений по электронной почте. Вы можете отказаться в любое время.",
            I_ACCEPT: "Я согласен(-на) с ",
            PRIVACY_POLICY: "Политикой конфиденциальности"
        }
    };

    public static translator(language: string): any {
        switch (language) {
            case "ru":
                return this._ru;
            default:
                return this._en;
        }
    }

}
